/**
 * @file: 卧柜层板 render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as Update from '../../update/index';
import Config from '../../config';

export default function update(cube: CubeNode): boolean {
    let isTrans: boolean = Config.get({
        moduleName: 'freezer',
        key: 'cabinetTransLayout'
    });
    UIToolkit.updateFreeLayerInShelfSize(cube.id);
    !isTrans && UIToolkit.cabinetsLayout([cube.id]);
    Update.updateDepByCubeId(cube.id);

    return true;
}
